
import {  OrderCreate, OrdersService, UserOrderResponse } from "@/api";

export const OrderUserService = {

    async list(): Promise<UserOrderResponse[]> {
        const dtos =
            await OrdersService.listMyOrdersOrdersOrdersGet();

        return dtos;
    },

    async getOrder(
        orderId: number
    ): Promise<UserOrderResponse> {

        const dto =
            await OrdersService
                .userGetOrderByIdOrdersIdGet(orderId);

        return dto;
    },

    async create(
        payload: OrderCreate
    ): Promise<UserOrderResponse> {

        const dto =
            await OrdersService
                .createOrderOrdersPost(payload);

        return dto;
    },
};